import {styled} from '@mui/material/styles'
import {Box, TextField, FormControlLabel, IconButton, Typography} from '@mui/material'

// Popover Paper styles helper - uses dynamic height calculation
export const getPopoverPaperStyles = (theme, anchorRect) => {
  // Calculate height from anchor position to bottom of viewport
  const topOffset = anchorRect?.bottom ?? 100
  const bottomMargin = 16
  const availableHeight = `calc(100vh - ${topOffset}px - ${bottomMargin}px)`

  return {
    width: 380,
    height: availableHeight,
    maxHeight: availableHeight,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[8]
  }
}

export const PopoverContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden'
})

export const PopoverHeader = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: 0,
  paddingBottom: 0
}))

export const PopoverTitle = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightSemibold
}))

export const CloseButton = styled(IconButton)({})

export const StyledCategoryDescription = styled(Typography)(({theme}) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  fontSize: theme.typography.subtitle1.fontSize
}))

export const SearchContainer = styled(Box)(({theme}) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(1)
}))

export const SearchTextField = styled(TextField)(({theme}) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    paddingRight: theme.spacing(0)
  }
}))

export const FilterListContainer = styled(Box)(({theme}) => ({
  flex: 1,
  overflowY: 'auto',
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  minHeight: 0 // Required for flex child to respect overflow
}))

export const FilterItemContainer = styled(Box)({})

export const FilterFormControlLabel = styled(FormControlLabel)(({theme}) => ({
  marginLeft: 0,
  marginRight: 0,
  marginBottom: theme.spacing(0.5),
  width: '100%',
  display: 'flex',
  '& .MuiFormControlLabel-label': {
    marginRight: '0',
    width: '100%',
    flex: 1
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

export const StyledFilterLabelContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: theme.spacing(1)
}))

export const StyledInfoIconButton = styled(IconButton)(({theme}) => ({
  padding: theme.spacing(0.25),
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

export const NoFiltersMessage = styled(Typography)(({theme}) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary
}))

export const FooterContainer = styled(Box)(({theme}) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  backgroundColor: theme.palette.hpBaseLighter
}))

export const FooterMessage = styled(Typography)(({theme}) => ({
  color: 'text.primary',
  fontStyle: 'italic',
  display: 'block',
  lineHeight: theme.typography.body1.lineHeight
}))
